import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, Input, Modal } from '@arco-design/web-react';

import { MAAS_INPUT_PLACEHOLDER, maasRequiredRules } from '@/delivery-type-plugin/capabilities/maas-init/form-messages';
import { getModalPopupContainer } from '@/delivery-type-plugin/utils/modalPopupContainer';

import { ModelSourceEntryCard } from './model-source-entry-card';
import sourceStyles from './model-source-setting.module.less';
import type { MaasModelSourceEntry } from './modelInstanceTypes';

const FormItem = Form.Item;

interface ModelFieldsEditModalProps {
  open: boolean;
  entry?: MaasModelSourceEntry;
  onClose: () => void;
  onSave: (patch: Pick<MaasModelSourceEntry, 'name' | 'size'>) => void;
}

/** 编辑已添加模型的服务名称与大小 */
export function ModelFieldsEditModal({ open, entry, onClose, onSave }: ModelFieldsEditModalProps) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open || !entry) return;
    form.setFieldsValue({ name: entry.name, size: entry.size });
  }, [entry, form, open]);

  return (
    <Modal
      visible={open}
      title={t('common:edit')}
      onCancel={onClose}
      onOk={async () => {
        await form.validate();
        const { name, size } = form.getFieldsValue();
        onSave({ name: String(name || '').trim(), size: String(size || '').trim() });
        onClose();
      }}
      unmountOnExit
      getPopupContainer={getModalPopupContainer}
    >
      <Form form={form} layout="vertical" className={sourceStyles.modalForm}>
        {entry ? (
          <div style={{ marginBottom: 16 }}>
            <ModelSourceEntryCard entry={entry} readOnly />
          </div>
        ) : null}
        <FormItem label={t('data-center:maas.service.name')} field="name" rules={maasRequiredRules(t('data-center:maas.service.name'))}>
          <Input placeholder={MAAS_INPUT_PLACEHOLDER} />
        </FormItem>
        <FormItem label={t('data-center:maas.model.size')} field="size" rules={maasRequiredRules(t('data-center:maas.model.size'))}>
          <Input placeholder="10Gi" />
        </FormItem>
      </Form>
    </Modal>
  );
}
